export default {
  title: '包装单位管理',

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '包装代码、包装名称',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置',
    searchPlaceholder: '搜索包装单位名称、代码'
  },

  // 操作按钮
  actions: {
    addPackageUnit: '新增包装单位',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    enableItem: '启用',
    disableItem: '禁用',
    ediCodeSetting: 'EDI代码设置',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    packageCode: '包装代码',
    packageNameCn: '包装名称（中文）',
    packageNameEn: '包装名称（英文）',
    status: '状态',
    operation: '操作',
    code2Digit: '包装代码（2位）',
    code4Digit: '包装代码（4位）',
    nameCn: '包装名称（中文）',
    nameEn: '包装名称（英文）',
    ediCode: 'EDI代码',
    codeCount: '{count}个代码',
    notSet: '未设置',
    tableTitle2Digit: '包装代码（2位）',
    tableTitle4Digit: '包装代码（4位）',
    tableTitleNameCn: '包装名称（中文）',
    tableTitleNameEn: '包装名称（英文）'
  },

  // 关联弹窗
  modal: {
    title: '新增包装单位',
    confirmText: '确认添加 ({count})',
    selected: '已选择 {count} 个包装单位，共 {total} 个可选',
    selectedStatus: '已选择 {count} 个包装单位，共 {total} 个可选',
    keyword: '关键词搜索',
    searchPlaceholder: '包装代码、包装名称、2位代码、4位代码',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置',
    // 新增包装单位弹窗
    addTitle: '新增包装单位',
    addConfirmText: '确认添加',
    selectedCount: '已选择 {count} 个包装单位',
    tableTitle2Digit: '包装代码（2位）',
    tableTitle4Digit: '包装代码（4位）',
    tableTitleNameCn: '包装名称（中文）',
    tableTitleNameEn: '包装名称（英文）'
  },

  // 确认对话框
  confirm: {
    enableItem: '确定要启用此包装单位吗？',
    disableItem: '确定要禁用此包装单位吗？',
    batchEnable: '确定要启用选中的 {count} 个包装单位吗？',
    batchDisable: '确定要禁用选中的 {count} 个包装单位吗？',
    toggleStatus: '确定要{action}此包装单位吗？'
  },

  // 表单验证
  validation: {
    selectItems: '请选择要关联的包装单位'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的包装单位',
    selectToDisable: '请选择要禁用的包装单位',
    selectToAssociate: '请选择要添加的包装单位',
    loadError: '数据加载失败',
    platformLoadError: '平台数据加载失败',
    associateError: '添加失败',
    associateSuccess: '已添加 {count} 个包装单位',
    statusToggleError: '操作失败',
    statusToggleSuccess: '状态切换成功',
    batchEnableError: '批量操作失败',
    batchEnableSuccess: '已启用 {count} 个包装单位',
    batchDisableError: '批量操作失败',
    batchDisableSuccess: '已禁用 {count} 个包装单位',
    ediCodeSaveSuccess: 'EDI代码设置成功',
    ediCodeSaveError: 'EDI代码保存失败'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  // EDI设置弹窗
  ediModal: {
    title: 'EDI代码设置',
    ediCodeList: 'EDI代码列表',
    platform: '平台',
    platformRequired: '请选择平台',
    platformPlaceholder: '选择平台',
    ediCode: 'EDI代码',
    ediCodeRequired: '请输入EDI代码',
    ediCodePlaceholder: '请输入EDI代码',
    addEdiCode: '添加EDI代码',
    deleteEdiCode: '删除',
    duplicateWarning: '平台重复',
    optional: '(非必填)',
    carrier: '承运人',
    carrierPlaceholder: '请选择承运人',
    duplicateRowsError: '第 {rows} 行存在重复的平台',
    duplicateRowsSaveError: '第 {rows} 行存在重复的平台，请修改后再保存'
  }
}